import React from "react";
import "./styles/CategoriesList.scss";
import { CategoryUI } from "../types";
import { ThemeLoader } from "./ThemeLoader";

interface CategoriesListProps {
  categories: CategoryUI[];
  selectedCategory: string | null;
  onSelectCategory: (categoryId: string) => void;
  isLoading: boolean;
}

export const CategoriesList: React.FC<CategoriesListProps> = ({
  categories,
  selectedCategory,
  onSelectCategory,
  isLoading,
}) => {
  if (isLoading) {
    return <ThemeLoader size="compact" />;
  }

  return (
    <div className="categories-list">
      <button
        className={`categories-list__item ${!selectedCategory ? "active" : ""}`}
        onClick={() => onSelectCategory("all")}
      >
        Все
      </button>
      {categories.map((category) => (
        <button
          key={category.id}
          className={`categories-list__item ${
            selectedCategory === category.id ? "active" : ""
          }`}
          onClick={() => onSelectCategory(category.id)}
        >
          {category.name}
        </button>
      ))}
    </div>
  );
};
